module.exports = __webpack_public_path__ + "static/media/after-you.tar.1c5b81e6.gz";